import { css } from 'styled-components';

export const pageContentContainer = css`
    width: calc(100% - 2rem);
    max-width: 64.3rem;
    margin-inline: auto;
`;
